import axios from '../lib/axios';
import { PRODUCT_UPDATE } from '../lib/endpoints/product';
import { PriceModel } from './price';
import { ProductTagModel } from './productTag';
import { PromotionModel } from './promotion';

export interface ProductMerchantModel {
  id: string;
  merchantId: string;
  productTagId: string;
  productMainGroupId: string;
  productDivisionNameId: string;
  productCategoryId: string;
  productSubCategoryId: string;
  zone: string;
  recommend: boolean;
  productNew: boolean;
  saleAmount: number;
  transactionFee: number;
  diliveryDate: string;
  promotionId: string;
  qtyPerPack: number;
  priceId: string;
  isActiveStatus: boolean;
  createdAt: string;
  updatedAt: string;
  inventory: {
    id: string;
    branchCode: string;
    itemcode: string;
    quantity: number;
    qtyPerPack: number;
    updatedAt: string;
  };
  productTag: ProductTagModel;
  promotion: PromotionModel;
  price: PriceModel;
  totalStock: number;
  stockQuantity: number;
  quantity: number
}

export const updateProductMerchant = async (
  id: string,
  input: {
    recommend: boolean;
    productNew: boolean;
    zone: boolean;
    saleAmount: number;
  }
) => {
  await axios.patch(`${PRODUCT_UPDATE}?id=${id}`, input);
};
